"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostFeatureExpVariationGroupSchema = exports.PatchFeatureExpVariationGroupSchema = exports.FeatureExpVariationGroupsWithPaginationSchema = exports.FeatureExpPaginationTypeSchema = exports.FeatureExpVariationGroupSchema = exports.FeatureExpTargetingGroupSchema = exports.FeatureExpTargetingItemSchema = exports.FeatureExpTargetingOperatorSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../variation/schemas");
const schemas_2 = require("../../../helpers/schemas");
exports.FeatureExpTargetingOperatorSchema = zod_1.z.enum([
    'EQUALS',
    'NOT_EQUALS',
    'GREATER_THAN',
    'LOWER_THAN',
    'CONTAINS',
    'NOT_CONTAINS',
    'GREATER_THAN_OR_EQUALS',
    'LOWER_THAN_OR_EQUALS',
]);
exports.FeatureExpTargetingItemSchema = zod_1.z.object({
    operator: exports.FeatureExpTargetingOperatorSchema,
    key: zod_1.z.string(),
    value: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string()), zod_1.z.boolean(), zod_1.z.number(), zod_1.z.array(zod_1.z.number())]),
});
exports.FeatureExpTargetingGroupSchema = zod_1.z.object({
    targetings: zod_1.z.array(exports.FeatureExpTargetingItemSchema),
});
exports.FeatureExpVariationGroupSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    is_default: zod_1.z.boolean(),
    allocation_config: zod_1.z.string(),
    order: zod_1.z.number(),
    targeting: zod_1.z.object({
        targetingGroups: zod_1.z.array(exports.FeatureExpTargetingGroupSchema),
    }),
    variations: zod_1.z.array(schemas_1.FeatureExpVariationSchema).optional(),
    created_at: zod_1.z.string(),
    formatted_created_at: schemas_2.ApiDateTimeSchema,
    updated_at: zod_1.z.string(),
    formatted_updated_at: schemas_2.ApiDateTimeSchema,
});
exports.FeatureExpPaginationTypeSchema = zod_1.z.object({
    current_items_count: zod_1.z.number(),
    current_page: zod_1.z.number(),
    total_count: zod_1.z.number(),
    items_per_page: zod_1.z.number(),
    last_page: zod_1.z.number(),
});
exports.FeatureExpVariationGroupsWithPaginationSchema = exports.FeatureExpPaginationTypeSchema.extend({
    items: zod_1.z.array(exports.FeatureExpVariationGroupSchema),
});
exports.PatchFeatureExpVariationGroupSchema = exports.FeatureExpVariationGroupSchema.partial().extend({
    account_id: zod_1.z.string(),
    campaign_id: zod_1.z.string(),
});
exports.PostFeatureExpVariationGroupSchema = exports.FeatureExpVariationGroupSchema.pick({
    name: true,
    is_default: true,
    allocation_config: true,
    order: true,
    targeting: true,
}).and(zod_1.z.object({
    account_id: zod_1.z.string(),
    campaign_id: zod_1.z.string(),
}));
//# sourceMappingURL=schemas.js.map